import { render, staticRenderFns } from "./ColorContainers.vue?vue&type=template&id=d2bca56c&scoped=true&"
import script from "./ColorContainers.vue?vue&type=script&lang=js&"
export * from "./ColorContainers.vue?vue&type=script&lang=js&"
import style0 from "./ColorContainers.vue?vue&type=style&index=0&id=d2bca56c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bca56c",
  null
  
)

export default component.exports